import analytics from '@/shared-utils/analytics'
import { type IGoogleAnalyticsTrackingType } from '@pcln/contentful-components'
import { useEffect } from 'react'

export default function useGoogleAnalyticsTracking(googleAnalyticsTracking?: IGoogleAnalyticsTrackingType) {
  useEffect(() => {
    if (googleAnalyticsTracking?.parameters) {
      analytics.fireGA4Event({
        event: 'view_promotion',
        attributes: {
          ...googleAnalyticsTracking.parameters?.attributes,
        },
      })
    }
  }, [googleAnalyticsTracking])
}
